import Hero from "../components/hero/Hero";
import About from "../components/sections/About";
import Advantages from "../components/sections/Advantages";
import Services from "../components/sections/Services";
import Fleet from "../components/sections/Fleet";
import Coverage from "../components/sections/Coverage";
import Clients from "../components/sections/Clients";
import Contact from "../components/sections/Contact";

export default function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Advantages />
      <Services />
      <Fleet />
      <Coverage />
      <Clients />
      <Contact />
    </>
  );
}
